import { Controller, Get, Post, Body, Param, Put, Delete } from '@nestjs/common';
import { UnitsDataService } from './units-service';
import { UnitsDataDto } from './units.dto';
import { CommonResponseModel } from '@project-management-system/shared-models';
import { ApplicationExceptionHandler } from '@project-management-system/backend-utils';
import { ApiBody } from '@nestjs/swagger';

@Controller('units-data')
export class UnitsDataController {
    constructor(
        private unitsDataService: UnitsDataService,
        private applicationExceptionHandler: ApplicationExceptionHandler
    ) { }

    @Post('/createUnitsData')
    @ApiBody({ type: UnitsDataDto })
    async createUnitsData(@Body() req?: any): Promise<CommonResponseModel> {
        try {
            return await this.unitsDataService.createUnitsData(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('/getAllUnitsData')
    async getAllUnitsData(): Promise<CommonResponseModel> {
        try {
            return await this.unitsDataService.getAllUnitsData();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('/updateUnitsData')
    @ApiBody({ type: UnitsDataDto })
    async updateUnitsData(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.unitsDataService.updateUnitsData(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('/activateOrDeactivateUnitdata')
    @ApiBody({ type: UnitsDataDto })
    async activateOrDeactivateUnitdata(@Body() dto: any): Promise<CommonResponseModel> {
        try {
            return await this.unitsDataService.activateOrDeactivateUnitdata(dto);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

}
